import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import PropTypes from 'prop-types';

import { Box, Flex, Text, Button } from 'core/ui/atoms';
import ModalV2 from 'core/ui/components/V2/ModalV2';
import { WeekContainer } from 'onramp/ui/components';

const SkipModal = ({
  selectedSkip,
  confirmedSkip,
  setConfirmedSkip,
  closeModal,
  handleUnSkipConfirmation,
  handleSkipConfirmation,
}) => {
  const weekDate = moment(selectedSkip?.deliveryPeriod?.startDate).format('MMMM Do');
  const editTillDate = moment(selectedSkip?.deliveryPeriod?.startDate)
    .subtract(10, 'days').format('dddd, MMMM Do');

  const isSkipped = selectedSkip?.skipped;
  const primaryAction = isSkipped ? handleUnSkipConfirmation : handleSkipConfirmation;
  const actionButtonText = isSkipped ? 'UNSKIP THIS WEEK' : 'SKIP THIS WEEK';

  return (
    <ModalV2 title='Edit My Calendar' fullWidth={true} data-account-info-modal onClose={closeModal}>
      <ModalTitle>Edit My Calendar</ModalTitle>
      <WeekContainer>Week of
        <WeekDateText>{weekDate}</WeekDateText>
      </WeekContainer>
      <SpacerS />
      <ModalContext>Skip or edit this week</ModalContext>
      <ModalContext>until 6:00 AM PST on {editTillDate}.</ModalContext>
      <Spacer />
      <ButtonContainer direction='column' justifyContent='center' alignItems='center'>
        <ConfirmButtonStyle $confirmedSkip={confirmedSkip} btn-outline onClick={() => setConfirmedSkip(!confirmedSkip)}>
          {actionButtonText}
        </ConfirmButtonStyle>
        <ButtonStyle btn-primary disabled={!confirmedSkip} onClick={primaryAction}>
          CONFIRM
        </ButtonStyle>
      </ButtonContainer>
    </ModalV2>
  );
};

SkipModal.propTypes = {
  selectedSkip: PropTypes.object.isRequired,
  confirmedSkip: PropTypes.bool.isRequired,
  setConfirmedSkip: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleUnSkipConfirmation: PropTypes.func.isRequired,
  handleSkipConfirmation: PropTypes.func.isRequired,
};

const WeekDateText = styled(Text)`
  color: ${(p) => p.theme.colors.creamWhite};
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-size: 18px;
  font-style: italic;
  font-weight: 800;
  line-height: 32px;
  letter-spacing: 0.54px;
  margin: 0px;
`;

const Spacer = styled(Box)`
  margin-top: 25px;
  margin-bottom: 25px;
`;

const SpacerS = styled(Box)`
  margin-top: 10px;
  margin-bottom: 10px;
`;

const ButtonContainer = styled(Flex)`
  margin-top: 20px;
  width: 100%;
  padding-left: 50px;
  padding-right: 50px;
  gap: 20px;
`;

const ButtonStyle = styled(Button)`
  width: 100%;
  margin-bottom: 10px;
  padding: 13px 32px
`;

const ConfirmButtonStyle = styled(Button)`
  width: 100%;
  margin-bottom: 10px;
  padding: 13px 32px;
  background: ${({ $confirmedSkip }) => $confirmedSkip ? '#C5D1C0' : 'none'};
  border-radius: 4px;
  border: 1px solid #36443A;
  color: ${({ theme }) => theme.colors.darkGreen};
  &:hover {
    background: ${({ $confirmedSkip }) => $confirmedSkip ? '#C5D1C0' : 'none'};
    color: unset;
  }
`;

const ModalTitle = styled(Text)`
  margin-top: 100px;
  text-align: center;
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0.9px;
  font-family: ${({ theme }) => theme.typography.familyLarken};
  color: ${({ theme }) => theme.colors.darkGreen};
`;

const ModalContext = styled(Text)`
  margin: 0px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  color: ${({ theme }) => theme.colors.primaryV2};
`;

export default SkipModal;
